import ApplicationService from "@/services/ApplicationService";

export default {
    namespaced: true,
    state: {
        status: "ready",
        recentApps: [],
        mostViewedApps: []
    },
    getters: {
        recentAndMostViewedAppsStatus: state => {
            return state.status;
        },
        recentApps: state => {
            return state.recentApps;
        },
        mostViewedApps: state => {
            return state.mostViewedApps;
        }
    },
    actions: {
        async fetchRecentAndMostViewedApps(context) {
            context.state.status = "loading";
            try {
                let response = await ApplicationService.getRecentAndMostViewedApplications();
                context.state.recentApps = response.data.RecentApplications;
                context.state.mostViewedApps = response.data.MostViewedApplications;
                context.state.status = "ready";
            } catch(e) {
                context.state.recentApps = [];
                context.state.mostViewedApps = [];
                context.state.status = "error";
            }
        },
        async fetchRecentAndMostViewedAppsWithoutLoading(context) {
            try {
                let response = await ApplicationService.getRecentAndMostViewedApplications();
                context.state.recentApps = response.data.RecentApplications;
                context.state.mostViewedApps = response.data.MostViewedApplications;
                context.state.status = "ready";
            } catch(e) {
                context.state.recentApps = [];
                context.state.mostViewedApps = [];
                context.state.status = "error";
            }
        }
    }
};
